import { Link } from "react-router-dom";
import { Facebook, Instagram } from "lucide-react";

// TikTok icon component (not available in lucide-react)
const TikTokIcon = ({ className }) => (
  <svg 
    className={className} 
    viewBox="0 0 24 24" 
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
  </svg>
);

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-12" data-testid="footer">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-8 mb-8 items-start">
          {/* Brand */}
          <div>
            <div className="mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_yourpackstory/artifacts/4x6lbiep_APA_Logo_Horizontal_Black.png" 
                alt="Apa Custom" 
                className="h-12 w-auto brightness-0 invert"
              />
            </div>
            <p className="text-gray-400 text-sm" style={{ fontFamily: 'Inter, sans-serif' }}>
              High-quality custom backpacks for sports teams and organizations worldwide.
            </p>
          </div>

          {/* Contact */}
          <div className="mt-4">
            <h4 className="font-bold mb-4" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
              Contact
            </h4>
            <ul className="space-y-2 text-gray-400 text-sm" style={{ fontFamily: 'Inter, sans-serif' }}>
              <li>
                <a href="mailto:Info@apacustom.com" className="hover:text-white transition-colors">
                  Info@apacustom.com
                </a>
              </li>
              <li>
                <a href="tel:+18004291223" className="hover:text-white transition-colors">
                  1-800-429-1223
                </a>
              </li>
            </ul>
          </div>

          {/* Social */}
          <div className="mt-4">
            <h4 className="font-bold mb-4" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
              Follow Us
            </h4>
            <div className="flex space-x-4">
              <a 
                href="https://facebook.com/apacustom" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-gray-400 hover:text-white transition-colors" 
                data-testid="social-facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a 
                href="https://instagram.com/apacustom" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-gray-400 hover:text-white transition-colors" 
                data-testid="social-instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a 
                href="https://tiktok.com/@apacustom" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-gray-400 hover:text-white transition-colors" 
                data-testid="social-tiktok"
              >
                <TikTokIcon className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 text-center text-gray-400 text-sm" style={{ fontFamily: 'Inter, sans-serif' }}>
          <p>&copy; {new Date().getFullYear()} Apa Custom. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;